import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './tooltip.scss';

export const Tooltip = (props) => {
  const { children, info, type, width, style, className } = props;

  const classType = `_${type}`;

  return (
    <div
      className={classnames('tooltip-container', className)}
      style={style}
      onClick={(event) => event.stopPropagation()}
    >
      {children}
      <div style={{ width }} className={classnames('tooltip-inner', classType)}>
        {info}
      </div>
    </div>
  );
};

Tooltip.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  info: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
    PropTypes.string,
  ]),
  type: PropTypes.string,
  width: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
};

Tooltip.defaultProps = {
  children: null,
  info: null,
  type: 'bottom', // bottom, top
  width: '128px',
  style: {},
};
